import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import React from 'react';
//import { Router, Route, IndexRoute, hashHistory, browserHistory, applyRouterMiddleware } from 'react-router';
import { BrowserRouter } from 'react-router-dom'
// import { useTransitions, withTransition } from 'react-router-transitions';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import store from './store';
import App from './components/Common/App'
// import Home from './components/Home/Index';
// import Register from './components/Home/Register';

// import AboutUS from './components/Home/Aboutus';
// import ContactUS from './components/Home/Contactus';
// function mapStyles(styles) {
//     return {
//         opacity: styles.opacity,
//         transform: `scale(${styles.scale})`,
//     };
// }
// function bounce(val) {
//     return spring(val, {
//         stiffness: 330,
//         damping: 22,
//     });
// }

// const bounceTransition = {
//     // start in a transparent, upscaled state
//     atEnter: {
//         opacity: 0,
//         scale: 1.2,
//     },
//     // leave in a transparent, downscaled state
//     atLeave: {
//         opacity: bounce(0),
//         scale: bounce(0.8),
//     },
//     // and rest at an opaque, normally-scaled state
//     atActive: {
//         opacity: bounce(1),
//         scale: bounce(1),
//     },
// };
// ReactDOM.render((
//     <Provider store={store}>
//         <Router>
//             {/* <AnimatedRoute
//                 path="/register"
//                 component={Register}
//                 atEnter={{ offset: -100, backgroundClolor:'red' }}
//                 atLeave={{ offset: -100 }}
//                 atActive={{ offset: 0 }}
//                 mapStyles={(styles) => ({
//                     transform: `translateX(${styles.offset}%)`,
//                 })}
//             /> */}
//             <Route>
//                 <IndexRoute component={App} />
//                 <Route exact path="/" component={App} componentName="Maindail" />
//                  <Route exact path="/register" component={Register} componentName="Register" />
//                 <Route exact path="/aboutus" component={AboutUS}  componentName="AboutUS"/>
//                 <Route exact path="/contactus" component={ContactUS}   componentName="ContactUS"/>
//             </Route>

//             {/* <Route path="/" component={withTransition(App)}>
//             <IndexRoute component={App} />
//             <Route exact path="/register" component={Register} componentName="Register" />
//                 <Route path="home" component={App} />
//                 <Route path="about-us" component={AboutUS} />
//             </Route> */}
//         </Router>
//     </Provider>
// ), document.getElementById('root'));


ReactDOM.render((
    <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </Provider>
  ), document.getElementById('root'))


// WEBPACK FOOTER //
// src/index.js